import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { DisplayOrderConfirmationState } from './prod-orders/prod-order'

@Directive({
  selector: '[appOrderConfirmationStateSelect]',
})
export class OrderConfirmationStateSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderSelectComponent)
  readonly enumTranslationService = inject(ElderEnumTranslationService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'displayValue'
    this.select.nullDisplay = 'context.noSelection'
    this.select.dataSource = this.enumTranslationService.enumDataSource(
      DisplayOrderConfirmationState,
      'order_confirmation_state'
    )
  }
}
